import MyAsset from "../../asset_strings";
import MusicSlider, {
  MusicSliderType,
} from "../../components/MusicSlider/MusicSlider";
import { MusicSliderDataTypes } from "../../components/MusicSlider/types";
import { RoutePattern } from "../../routes/RoutePattern";

const data: MusicSliderDataTypes[] = [
  {
    img: MyAsset.ALBUM_ART,
    link: "https://lnk.to/SAINtJHN-IfTomorrowNeverComesWE",
    title: "If Tomorrow Never Comes",
  },
  {
    img: MyAsset.FESTIVAL_SEASON,
    link: "http://lnk.to/SAINtJHN-FestivalSeasonWE",
    title: "Festival Season",
  },
  {
    img: MyAsset.COLLECTION_ONE,
    link: "http://lnk.to/SAINtJHN-CollectionOne",
    title: "Collection One",
  },
  {
    img: MyAsset.GHETTO_LENNY,
    link: "http://lnk.to/SAINtJHN-GhettoLennysLoveSongs",
    title: "Ghetto Lenny's Love Songs",
  },
  {
    img: MyAsset.WHILE_THE_WORLD,
    link: "http://lnk.to/SAINtJHN-WhileTheWorldWasBurning",
    title: "While the World Was Burning",
  },
];

export default function Music() {
  return (
    <div
      id={RoutePattern.MUSIC}
      className="w-full md:min-h-screen flex flex-col justify-center items-center py-[100px] md:py-0"
    >
      <h2 className="section-heading">MUSIC</h2>
      <div className="mt-[--space-btw-sections] w-full">
        <MusicSlider data={data} />
      </div>
    </div>
  );
}
